<div
    class="cookie-consent-modal-overlay"
    [class.cookie-consent-modal-overlay--manage]="view === 'manage'"
    *ngIf="showModal"
>
    <div
        class="cookie-consent-modal"
        [class.cookie-consent-modal--manage]="view === 'manage'"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookieConsentModalTitle"
    >
        <div class="cookie-consent-modal__header">
            <h2 id="cookieConsentModalTitle" [ngSwitch]="view">
                <ng-container *ngSwitchCase="'manage'" translate>Manage preferences</ng-container>
                <ng-container *ngSwitchCase="'unavailable'" translate>Preferences can't be saved in this browser</ng-container>
                <ng-container *ngSwitchDefault translate>Cookie preferences</ng-container>
            </h2>
            <button
                *ngIf="dismissable"
                type="button"
                class="cookie-consent-modal__close"
                aria-label="Close"
                (click)="dismiss()"
            >&times;</button>
        </div>

        <div class="cookie-consent-modal__body">
            <ng-container *ngIf="view === 'choice'">
                <p translate
                    >We use strictly necessary cookies to keep you signed in, secure your session and provide the services you
                    request. With your permission, we also use optional analytics and product-experience services to understand
                    usage and support users. You can accept optional cookies, reject them, or choose individual services.</p
                >
            </ng-container>

            <ng-container *ngIf="view === 'manage'">
                <p translate
                    >Choose which optional services this application may use. Strictly necessary cookies are always active
                    because they support authentication, security, session management and your cookie preference. Optional
                    services remain off unless you enable them.</p
                >

                <div class="cookie-consent-modal__categories">
                    <div class="cookie-consent-modal__category">
                        <div class="cookie-consent-modal__category-row">
                            <div class="cookie-consent-modal__category-copy">
                                <strong translate>Authentication, security and your cookie choice</strong>
                                <span translate>Signs you in, keeps your session, and remembers this preference. These cannot be turned off.</span>
                            </div>
                            <span class="cookie-consent-modal__lock" translate>Always active</span>
                        </div>
                    </div>

                    <ng-container *ngFor="let category of categories">
                        <div
                            class="cookie-consent-modal__category"
                            *ngFor="let tracker of category.trackers; trackBy: trackByTrackerId"
                            (click)="toggleTracker(tracker.id, !draft[tracker.id])"
                        >
                            <div class="cookie-consent-modal__category-row">
                                <div class="cookie-consent-modal__category-copy">
                                    <strong>{{ tracker.nameKey | translate }}</strong>
                                    <span>{{ tracker.descriptionKey | translate }}</span>
                                </div>
                                <button
                                    type="button"
                                    class="cookie-consent-modal__toggle"
                                    [class.cookie-consent-modal__toggle--on]="draft[tracker.id]"
                                    role="switch"
                                    [attr.aria-checked]="draft[tracker.id]"
                                    [attr.aria-label]="tracker.nameKey | translate"
                                    (click)="onToggleClick($event, tracker.id)"
                                >
                                    <span class="cookie-consent-modal__toggle-knob" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="view === 'unavailable'">
                <p role="alert" translate
                    >Your browser is blocking cookies for this site, so we can't record a cookie choice here. You can carry on
                    — every optional service stays switched off, and we will ask again if cookies are allowed later.</p
                >
                <p translate>To choose, allow cookies for this site in your browser settings and reload this page.</p>
            </ng-container>

            <p>
                <a class="cookie-consent-modal__btn cookie-consent-modal__btn--link" [href]="policyPath" target="_blank" rel="noopener noreferrer" translate
                    >Cookie Policy</a
                >
            </p>
        </div>

        <div class="cookie-consent-modal__footer">
            <button *ngIf="view === 'choice'" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--secondary" (click)="manage()" translate>
                Manage preferences
            </button>
            <button *ngIf="view === 'choice'" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--secondary" (click)="rejectAll()" translate>
                Reject optional cookies
            </button>
            <button *ngIf="view !== 'manage'" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--primary" [disabled]="view === 'unavailable'" (click)="acceptAll()" translate>
                Accept optional cookies
            </button>

            <button *ngIf="view === 'unavailable'" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--primary" (click)="continueWithoutRecord()" translate>
                Continue
            </button>
            <button *ngIf="view === 'manage' && cameFromChoice" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--link" (click)="backToChoice()" translate>
                Back
            </button>
            <button *ngIf="view === 'manage'" type="button" class="cookie-consent-modal__btn cookie-consent-modal__btn--primary" (click)="saveSelection()" translate>
                Save preferences
            </button>
        </div>
    </div>
</div>
